import React from "react";
import Marquee from "react-fast-marquee";
// SCSS
import "./Skill.scss";
//Assets
import { skillsData } from '../../data/skillsData'
import { skillsImage } from '../../utils/skillsImage'
//Components
import Title from "../ui-components/title/title";


const skill = () => (
    <div className="skills" id="skills">
        <div className="wrapper">
            <Title title="Skills." />
        </div>
        <div className="wrapper2">
            <div className="skillsContainer">
                <div className="skill--scroll">
                    <Marquee
                        className="marquee-gradient"
                        gradient={false}
                        gradientWidth="0"
                        speed={80}
                        pauseOnHover={true}
                        pauseOnClick={true}
                        delay={0}
                        play={true}
                        direction="left"
                    >
                        {skillsData.map((skill, id) => (
                            <div className="skill--box" key={id} >
                                <img className="bounce" src={skillsImage(skill)} alt={skill} />
                                <h3 className="font12">
                                    {skill}
                                </h3>
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </div>

    </div>
);

export default skill;
